import React from 'react';
// import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import enums from 'misc/enums';
import PageContext from './PageContext';

const propTypes = {
};

@autobind
class BaseComponent extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  getMyUser() {
    return this.context.basePage.getMyUser();
  }

  getMyUserId() {
    return this.context.basePage.getMyUserId();
  }

  getMyNickName() {
    return this.context.basePage.getMyNickName();
  }

  getMyUserType() {
    return this.context.basePage.getMyUserType();
  }

  isMeTeamAgency() {
    return this.context.basePage.isMeTeamAgency();
  }

  isMeRealAgency() {
    return this.context.basePage.isMeRealAgency();
  }

  isLoggedIn() {
    return this.context.basePage.isLoggedIn();
  }

  parseQueryParam(paramName) {
    return this.context.basePage.parseQueryParam(paramName);
  }

  navigateTo(dest) {
    this.context.basePage.navigateTo(dest);
  }

  emitEvent(eventName, ...args) {
    this.context.eventEmitter.emit(eventName, ...args);
  }

  addEventListener(eventName, listener) {
    return this.context.eventEmitter.addListener(eventName, listener);
  }

  async callService(relUrl, ...args) {
    return this.context.basePage.callService(relUrl, ...args);
  }

  async callServiceForRemoteObject(relUrl, ...args) {
    return this.context.basePage.callServiceForRemoteObject(relUrl, ...args);
  }

  async callServiceForPagedObjects(relUrl, ...args) {
    return this.context.basePage.callServiceForPagedObjects(relUrl, ...args);
  }

  async callServiceForRemoteObjects(relUrl, ...args) {
    return this.context.basePage.callServiceForRemoteObjects(relUrl, ...args);
  }

  async callServiceForObject(relUrl, ...args) {
    return this.context.basePage.callServiceForObject(relUrl, ...args);
  }

  async callServiceForObjects(relUrl, ...args) {
    return this.context.basePage.callServiceForObjects(relUrl, ...args);
  }

  async callServiceForString(relUrl, ...args) {
    return this.context.basePage.callServiceForString(relUrl, ...args);
  }

  async callServiceForLong(relUrl, ...args) {
    return this.context.basePage.callServiceForLong(relUrl, ...args);
  }

  async callServiceForBoolean(relUrl, ...args) {
    return this.context.basePage.callServiceForBoolean(relUrl, ...args);
  }

  notifySuccess(title, content) {
    this.context.basePage.notifySuccess(title, content);
  }

  notifyWarning(title, content) {
    this.context.basePage.notifyWarning(title, content);
  }

  notifyError(title, content) {
    this.context.basePage.notifyError(title, content);
  }

  isInAppWebview() {
    return this.context.basePage.isInAppWebview();
  }

  isInRniOSWebView() {
    return this.context.basePage.isInRniOSWebView();
  }

  isInRnAndroidWebView() {
    return this.context.basePage.isInRnAndroidWebView();
  }

  isInRenderableState() {
    return true;
  }

  e2t(type, enumValue) {
    return enums.toText(type, enumValue);
  }

  renderLoadingComponent() {
    return null;
  }

  renderContent() {
    throw new Error('You have to implement the method!');
  }

  render() {
    if (this.isInRenderableState()) {
      return this.renderContent();
    } else {
      return this.renderLoadingComponent();
    }
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
BaseComponent.propTypes = propTypes;
BaseComponent.contextType = PageContext;

export default BaseComponent;
